// extracted by mini-css-extract-plugin
export default {"root":"nGGq6qkWfcwi1sCeVrSt","left":"gA6bJPjLa4L0xvkLs_kM","right":"UX4RNf31f6uA2nk2XpBs"};